import { Component } from '@angular/core';
import { ActivatedRoute, Data } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import { map, tap } from 'rxjs/operators';

import { NSCommons } from '@ruby/configs/common.constants';
import { EBillCarDisputeActions, fromEBillCarDispute } from '@ruby/modules/ebill/store/ebill-car-dispute.index';
import { selectCarDisputeState } from '@ruby/modules/ebill/store/selectors/ebill-car-dispute.selectors';
import { ITransaction } from '@ruby/shared/models/commons/transaction.interface';
import { IEBillCarDetailsDispute, IEBillInvoiceSummary } from '@ruby/shared/models/ebill/ebil.interface';

@Component({
  selector: 'ng-ebill-car-dispute-container',
  template: `
    <ng-ebill-car-dispute *ngIf="(store$ | async) as store"
                          [invoiceNumber]="bill.freightBillNumber"
                          [carDetails]="store.state.carDetails"
                          [billSequence]="bill.billSequence"
                          [loading]="store.state.loading"
                          [isDisputeDisabled]="isDisputeDisabled"
                          (dispute)="dispatchDisputeAction($event)"
                          (toggleDisputeButton)="toggleDisputeButton()"
    >
    </ng-ebill-car-dispute>
  `
})
export class EBillCarDisputeContainer {
  store$: Observable<{ state: fromEBillCarDispute.State; userRacf?: string }>;
  bill!: IEBillInvoiceSummary;
  userRacf?: string;
  isDisputeDisabled = true;
  private acrSubscription!: Subscription;

  constructor(private store: Store<fromEBillCarDispute.State>, private acr: ActivatedRoute) {
    this.store$ = store.select(selectCarDisputeState).pipe(tap((st: { state: fromEBillCarDispute.State; userRacf?: string }) => {
      this.userRacf = st.userRacf;
      this.isDisputeDisabled = st.state.isDisputeDisabled;
    }));
    this.parseTransaction();
  }

  /**
   * Dispatch Dispute Action
   *
   * @summary dispatch dispute action
   * @param $event: Partial<Partial<IEBillCarDetailsDispute>>
   * @returns void
   */
  dispatchDisputeAction($event: Partial<Partial<IEBillCarDetailsDispute>>): void {
    this.store.dispatch(EBillCarDisputeActions.disputeBills({
      data: {
        ...this.bill,
        waybillDate: NSCommons.formatNSDate(this.bill.waybillDate, 'yyyyMMdd'),
        origBillDate: NSCommons.formatNSDate(this.bill.origBillDate!, 'yyyyMMdd'),
        ...$event,
        origRoadNumber: this.bill.roadNumber,
        origAuditCode: this.bill.auditCode,
        userRacf: this.userRacf
      } as IEBillCarDetailsDispute
    }));
  }

  /**
   * Dispatch Toggle Dispute Button
   *
   * @summary dispatch dispute button
   * @returns void
   */
  toggleDisputeButton(): void {
    this.isDisputeDisabled = !this.isDisputeDisabled;
  }

  private parseTransaction(): void {
    this.acrSubscription = this.acr.data.pipe(
      map((data: Data) => data.transaction)
    ).subscribe((transaction: ITransaction) => {
      if (transaction) {
        this.bill = JSON.parse(transaction.parameters.eBill!) as IEBillInvoiceSummary;
        this.load();
      }
    });
  }

  private load(): void {
    this.store.dispatch(EBillCarDisputeActions.loadDetails({
      data: {
        billNumber: this.bill.billNumber!,
        customerNumber: this.bill.customerNumber
      }
    }));
  }
}
